export default {

  QUERY_SOURCE: 'source',


  SOURCE_LINE: 'line',

}